export const dummyCameras = {
  data: [
    {
      id: "1",
      cameraNumber: "CAM-001",
      cameraKey: "KEY-123456",
      simNumber: "9876543210",

      driverId: "1",
      driverName: "Ravi Kumar",

      status: 1,
      createdOn: "2026-03-01",
    },
    {
      id: "2",
      cameraNumber: "CAM-002",
      cameraKey: "KEY-789456",
      simNumber: "9123456780",

      driverId: "2",
      driverName: "Amit Sharma",

      status: 0,
      createdOn: "2026-03-05",
    },
  ],
  total: 2,
};